(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelStyle',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#travelstyle-trip_type').on('change', function toggleCruiseLand() {
			var tripType = $(this).val();

			if (tripType === 'Cruise') {
				$('#cruise-trip').removeClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#tour-company').addClass('hidden');
				$('#travelstyle-river_cruise_trip').val("");
				$('#travelstyle-land_trip').val("");
			} else if (tripType === 'River Cruise') {
				$('#river-cruise-trip').removeClass('hidden');
				$('#cruise-trip').addClass('hidden');
				$('#tour-company').addClass('hidden');
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-land_trip').val("");
			} else if (tripType && tripType !== '') {
				$('#cruise-trip').addClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#tour-company').removeClass('hidden');
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-river_cruise_trip').val("");
			} else {
				$('#tour-company').addClass('hidden');
				$('#cruise-trip').addClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#travelstyle-land_trip').val("");
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-river_cruise_trip').val("");
			}

			// Handle brand specialty dropdown based on trip type
			handleBrandSpecialtyDropdown(tripType);
		});

		/**
		 * Show/hide and populate the brand specialty dropdown based on selected trip type.
		 * Brand data is loaded from w2nBrandSpecialties (set in the view).
		 */
		function handleBrandSpecialtyDropdown(tripType) {
			var $brandFieldset    = $('#brand-specialty');
			var $brandSelect      = $('#travelstyle-brand_specialty');
			var brandsMap         = window.w2nBrandSpecialties || {};
			var brands            = brandsMap[tripType] || {};
			var brandKeys         = Object.keys(brands);
			var noBrandsTripTypes = [
				'Custom Designed Trip',
				'Custom Designed Trips',
				'Unsure/Open to Ideas'
			];

			// Debug logging - remove after testing
			console.log('handleBrandSpecialtyDropdown called');
			console.log('tripType:', tripType);
			console.log('brandsMap:', brandsMap);
			console.log('brands for this tripType:', brands);
			console.log('brandKeys.length:', brandKeys.length);
			console.log('$brandFieldset found:', $brandFieldset.length);
			console.log('$brandSelect found:', $brandSelect.length);

			// Clear existing options
			$brandSelect.empty();

			// Hide for empty selection or trip types that should not show brands
			if (!tripType || noBrandsTripTypes.indexOf(tripType) !== -1) {
				console.log('Hiding: no tripType or excluded tripType');
				$brandFieldset.addClass('hidden');
				return;
			}

			// If no brands mapped for this trip type, hide the fieldset
			if (brandKeys.length === 0) {
				console.log('Hiding: no brands for this tripType');
				$brandFieldset.addClass('hidden');
				return;
			}

			// Add default empty option
			$brandSelect.append('<option value="">Please Select</option>');

			// Populate brands for this trip type
			$.each(brands, function appendBrand(value, label) {
				$brandSelect.append(
					'<option value="' + $('<div/>').text(value).html() + '">'
					+ $('<div/>').text(label).html()
					+ '</option>'
				);
			});

			console.log('Showing brand fieldset with', brandKeys.length, 'options');
			// Show the brand fieldset
			$brandFieldset.removeClass('hidden');
		}

		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
			e.stopPropagation();
		});

		$('select#travelstyle-where_to_next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('#travelstyle-where_to_next option').each(function selecting(e, val) {
				var $self = $(this);

				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');
	};

	form.confirmation = function confirmation(response)
	{
		// this means a confirm dialog needs to be thrown due to a connection error with Satori
		if (response.data.response_code === "connection_error") {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// this is a Satori rejected address with no suggested alternative. User still should be able to force it through
		} else if (response.data.response_code > 100) {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// a Satori alternate address suggested.  Need for user to confirm what to do with it
		} else {
			Adzuki.AddressVerification.confirmWithSuggestion(response, form.name);
		}
	};

}(jQuery, window.Adzuki || {}));
